import styled from 'styled-components';
import { Card, Typography, Collapse } from 'antd';
import { DefaultTheme } from 'styled-components';

const { Title, Text } = Typography;

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MainContent = styled.main`
  flex: 1;
  padding: 16px;
`;

export const PageTitle = styled(Title)`
  margin-bottom: 16px !important;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const AnalyticsCard = styled(Card)<{ isSelected: boolean; theme?: DefaultTheme }>`
  cursor: pointer;
  transition: all 0.3s ease !important;
  border: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
  background-color: ${(props) =>
    props.isSelected
      ? getThemeValue(props, '#4a5568', '#e6f4ff')
      : getThemeValue(props, '#1a202c', '#ffffff')} !important;
  box-shadow: ${(props) =>
    getThemeValue(
      props,
      '0 4px 6px rgba(0, 0, 0, 0.3)',
      '0 2px 4px rgba(0, 0, 0, 0.1)'
    )} !important;

  &:hover {
    background-color: ${(props) => getThemeValue(props, '#4a5568', '#f5f5f5')} !important;
    transform: translateY(-2px);
    box-shadow: ${(props) =>
      getThemeValue(
        props,
        '0 6px 12px rgba(0, 0, 0, 0.4)',
        '0 4px 8px rgba(0, 0, 0, 0.15)'
      )} !important;
  }

  .ant-card-body {
    padding: 16px !important;
  }
`;

export const CardTitle = styled(Title)`
  font-size: 20px !important;
  font-weight: 600 !important;
  margin-bottom: 8px !important;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const CardDescription = styled(Text)`
  font-size: 18px !important;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;

export const DetailsContainer = styled.div`
  margin-top: 16px;
`;

export const StyledCollapse = styled(Collapse)`
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  border: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
  border-radius: 6px !important;

  .ant-collapse-item {
    border-bottom: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;

    &:last-child {
      border-bottom: none !important;
    }
  }

  .ant-collapse-header {
    background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
    padding: 16px !important;
  }

  .ant-collapse-content {
    background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    border-top: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
  }

  .ant-collapse-content-box {
    padding: 16px !important;
  }
`;

export const DetailTitle = styled(Title)`
  font-size: 18px !important;
  margin-bottom: 16px !important;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const DetailText = styled(Text)`
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
  margin-bottom: 16px !important;
  display: block !important;
`;
